import React, { useCallback, useMemo, useState } from "react";
import { useDropzone } from "react-dropzone";
import Swal from "sweetalert2";
import { postFiles } from "../../configs/api";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "23px",
  borderWidth: 1,
  borderRadius: 6,
  borderColor: "#D3D2DA",
  borderStyle: "dashed",
  backgroundColor: "#F2F3F7",
  color: "#75748B",
  outline: "none",
  transition: "border .24s ease-in-out",
};

const focusedStyle = {
  borderColor: "var(--primary-color)",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

export default function FileDropzone({
  // You must enter an object that contains the file types you want to accept.
  // Check: https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  // Example : {"image/*": [".png", ".gif", ".jpeg", ".jpg"]}
  filesAccept = { "application/pdf": [] },

  setState,
  value,
  multiple = false,
  maxSize,
  name,
  setLoading
}) {


  const onDrop = useCallback(async (acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length > 0) {
      // toast.error(rejectedFiles[0].errors[0].code.replaceAll("-", " "));

      Swal.fire({
        icon: "error",
        title: rejectedFiles[0].errors[0].message,
        customClass: "swal-wide",
      });
    } else {
      try {

        if (typeof setLoading == 'function') {
          setLoading(true);
        }

        const newFiles = await postFiles({
          file: acceptedFiles[0],
          type: "parent",
        });
        setState((prev) => [...prev, newFiles.data]);

        Swal.fire({
          icon: "success",
          title: "تم تحميل الملف بنجاح",
          customClass: "swal-wide",
        });

        if (typeof setLoading == 'function') {
          setLoading(false);
        }
        
      } catch (error) {
        console.log("error: ", error);

        if (error?.response?.status === 429) {
          Swal.fire({
            icon: "error",
            title: "عمليات ارسال متكررة، الرجاء المحاولة بعد 15 دقيقة",
            customClass: "swal-wide",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "هنالك خطأ ما، الرجاء المحاولة لاحقا",
            customClass: "swal-wide",
          });
        }
        
        if (typeof setLoading == 'function') {
          setLoading(false);
        }
      }
    }
  }, []);

  const {
    getRootProps,
    getInputProps,
    isFocused,
    fileRejections,
    isDragAccept,
    isDragReject,
    isDragActive,
    acceptedFiles,
  } = useDropzone({
    onDrop,
    accept: filesAccept,
    noClick: false,
    multiple: multiple,
    maxSize: maxSize,
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject],
  );

  return (
    <div className='w-full flex justify-center'>
      <div className='w-full' {...getRootProps({ style })}>
        <input name={name} {...getInputProps()} />
        <div className='flex flex-col gap-2 items-center'>
          <div className=''>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='30'
              height='30'
              viewBox='0 0 40 40'
            >
              <g
                id='Group_127754'
                data-name='Group 127754'
                transform='translate(-1463 -631)'
              >
                <g
                  id='Ellipse_31823'
                  data-name='Ellipse 31823'
                  transform='translate(1463 631)'
                  fill='none'
                  stroke='var(--primary-color)'
                  strokeWidth='2'
                >
                  <circle cx='20' cy='20' r='20' stroke='none' />
                  <circle cx='20' cy='20' r='19' fill='none' />
                </g>
                <path
                  id='noun-add-25957_2_'
                  data-name='noun-add-25957 (2)'
                  d='M96.723,86.271H88.275V77.822a.988.988,0,1,0-1.976,0v8.449H77.85a.988.988,0,1,0,0,1.976H86.3V96.7a.988.988,0,1,0,1.976,0V88.247h8.449a.988.988,0,1,0,0-1.976Z'
                  transform='translate(1395.713 563.741)'
                  fill='var(--primary-color)'
                />
              </g>
            </svg>
          </div>
          {isDragActive ? (
            <div>
              <span className='text-primary3 text-sm font-normal select-none'>
                اسحب هنا ...
              </span>
            </div>
          ) : (
            <div className=''>
              <span className='text-primary3 text-sm font-normal select-none'>
                {" "}
                اسحب الملف هنا او{" "}
              </span>
              <label
                htmlFor={"uploadCertificate"}
                className='text-primary_1 text-sm font-medium cursor-pointer select-none'
              >
                اختار
              </label>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
